module.exports = __webpack_public_path__ + "img/2.6fd58dfe.svg";